/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { TrackingProvider } from "./src/context/TrackingContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./src/i18n";

export const onInitialClientRender = () => {
    const script = document.createElement("script")
  script.src = "https://cloud.umami.is/script.js"
  script.async = true
  script.defer = true
  script.setAttribute("data-website-id", "47286814-1386-4379-9542-93f2c394fe2b")
  document.body.appendChild(script)
}


export const wrapRootElement = ({ element }) => (
  
  <TrackingProvider>
  <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
  </TrackingProvider>
  
);